import React from "react";
import cx from "classnames";

import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;

import XtSvg from "components/xt/svg";

import styles from "./index.module.scss";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  noIcon?: boolean;
}

const AppDivNoData: React.FC<Props> = ({ label, noIcon, className, ...rest }) => {
  const t = useTranslation();

  return (
    <div className={cx(styles.main, className)} {...rest}>
      {!noIcon && <XtSvg icon={`noData`} />}
      <div>{label || t("trade.noData")}</div>
    </div>
  );
};

export default AppDivNoData;
